export function openAndReadFile(accept?: string) {
  return new Promise<string | ArrayBuffer | null>((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.style.display = 'none';
    input.accept = accept || '*';

    document.body.append(input);

    input.click();
    input.addEventListener('change', (ev) => {
      const fileInput = ev.target as HTMLInputElement;

      const file = fileInput?.files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          fileInput.value = '';
          const content = event.target?.result;
          if (content) {
            resolve(content);
          }
        };
        reader.readAsText(file);
      } else {
        resolve(null);
      }
    });
  });
}

type TReadFile = {
  content: string | ArrayBuffer;
  name: string;
};

export function openAndReadFiles(
  inputProps?: Partial<{
    accept: string;
    multiple: string;
  }>,
) {
  return new Promise<TReadFile[]>((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.style.display = 'none';
    document.body.append(input);
    Object.assign(input, inputProps);

    input.addEventListener('change', (ev) => {
      const fileInput = ev.target as HTMLInputElement;

      if ((fileInput?.files?.length ?? 0) === 0) {
        resolve([]);
      } else {
        const files: (TReadFile | null)[] = [];

        const sources = fileInput!.files!;
        [...sources].forEach((c) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            fileInput.value = '';
            const content = event.target?.result;
            if (content) {
              files.push({
                content,
                name: c.name,
              });
            } else {
              files.push(null);
            }

            if (files.length === sources.length) {
              resolve(files.filter((c): c is TReadFile => !!c));
            }
          };
          reader.readAsText(c);
        });
      }
    });

    input.click();
  });
}
